import RadioCardListPage from "@components/RadioCardListPage"
import { isHomeDesignFlow } from "@helpers/localStorage"

const OPTIONS = [
  { emoji: "🦋", key: "transformed" },
  { emoji: "💎", key: "polished" },
  { emoji: "🔥", key: "bold" },
  { emoji: "🌟", key: "authentic" },
  { emoji: "🎭", key: "versatile" },
]

const HOME_OPTIONS = [
  { emoji: "✨", key: "dreamSpace" },
  { emoji: "🧘", key: "calmFunctional" },
  { emoji: "🥂", key: "impressGuests" },
  { emoji: "📦", key: "clutterFree" },
  { emoji: "📈", key: "greaterValue" },
]

export default function FutureLookPage() {
  if (isHomeDesignFlow()) {
    return (
      <RadioCardListPage
        translationKey="futureLookHomeDesign"
        options={HOME_OPTIONS}
      />
    )
  }
  return <RadioCardListPage translationKey="futureLook" options={OPTIONS} />
}
